import { DetailsDisclosure } from '@/scripts/theme/details-disclosure';
import { debounce, TsDOM as q } from '@/scripts/core/TsDOM'
import {
  scaleValue,
} from '@/scripts/core/global'
import {type StickyHeader } from '@/scripts/theme/sticky-header';
import { SELECTORS } from '@/scripts/core/global';
import { UcoastEl } from '../core/UcoastEl';

export class HeaderMenu extends DetailsDisclosure {
  static override htmlSelector = 'header-menu'
  header: StickyHeader | null
  hoverSummary?: HTMLElement
  detailsId?: string
  private _closeTimer?: number

  constructor() {
    super()
    this.header = q.rs<StickyHeader>(SELECTORS.headerWrapper)
    this.hoverSummary = q.os('summary[data-summary-hover="on"]', this)
    this.detailsId = q.oa(this.mainDetailsToggle, 'id')
    this.initHoverSummary()
  }

  initHoverSummary() {
    if (!this.hoverSummary || !this.detailsId) return

    this.hoverSummary.addEventListener('click', (_) => {
      void window.Ucoast.mediaManager.playAllInContainer(this.mainDetailsToggle)
      window.setTimeout(() => {
        void window.Ucoast.mediaManager.playAllInContainer(this.mainDetailsToggle)
      }, 3)
    })

    this.hoverSummary.addEventListener('mouseenter', (_) => {
      if (this._closeTimer) {
        window.clearTimeout(this._closeTimer)
        this._closeTimer = undefined
      }
      void window.Ucoast.mediaManager.playAllInContainer(this.mainDetailsToggle)
      const openMenuId = window.Ucoast.openMenuId
      if (openMenuId && openMenuId === this.detailsId) return
      window.Ucoast.openMenuId = this.detailsId
      this.mainDetailsToggle.setAttribute('open', '')
      this.animations?.forEach((animation) => animation.play())
      this.hoverSummary?.setAttribute('aria-expanded', 'true')
      void window.Ucoast.mediaManager.playAllInContainer(this.mainDetailsToggle)
      this.header?.classList.add('is-hovering')
    })

    this.addEventListener('mouseleave', () => {
      this._closeTimer = window.setTimeout(() => {
        this.close()
      })
    })

    this.addEventListener('mouseenter', () => {
      if (this._closeTimer) {
        window.clearTimeout(this._closeTimer)
        this._closeTimer = undefined
      }
    })

    this.mainDetailsToggle.addEventListener('keyup', q.onKeyUpEscape)
  }

  override onToggle() {
    if (!this.header) return
    this.header.preventHide = this.mainDetailsToggle.open

    if (
      document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !==
      ''
    )
      return
    const viewport = window.innerWidth >= 750 ? 'desktop' : 'mobile'
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `calc(${scaleValue(this.header.getBoundingClientRect().bottom, viewport)} * var(--ax))`
    )
  }

  override close() {
    super.close()
    if (!window.Ucoast.openMenuId) {
      this.header?.classList.remove('is-hovering')
    }
    this.hoverSummary?.setAttribute('aria-expanded', 'false')
    // if (this._closeTimer) {
    //   window.clearTimeout(this._closeTimer)
    //   this._closeTimer = undefined
    // }
  }
}

let preserveTallestMenuHeight = 0;

export class MegaMenu extends UcoastEl {
  static  htmlSelector = 'header-mega-menu';
  header: StickyHeader | null
  menuItems: NodeListOf<HTMLElement>;
  menuContentElements: NodeListOf<HTMLElement>;

  constructor() {
    super()
    this.header = q.rs<StickyHeader>(SELECTORS.headerWrapper);
    this.menuItems = q.rl<HTMLElement>(".mega-menu", this);
    this.menuContentElements = q.rl<HTMLElement>(".mega-menu__content", this);
    this.getTallestFromMenuItem();
    this.init();
  }

  init() {
    this.menuItems.forEach((menuItem) => {
      menuItem.addEventListener('mouseenter', this.onMouseEnter.bind(this, menuItem))
      menuItem.addEventListener('mouseleave', this.onMouseLeave.bind(this, menuItem))
    })
    this.setMenuHeight(this);
    window.addEventListener('resize', debounce(this.onResizeUpdateMenuHeight.bind(this), 300))
  }

  onMouseEnter(menuItem: HTMLElement) {
    menuItem.classList.add('is-open')
    this.header?.classList.add('is-hovering')
  }

  onMouseLeave(menuItem: HTMLElement) {
    menuItem.classList.remove('is-open')
    this.header?.classList.remove('is-hovering') 
  }

  getTallestFromMenuItem() {
    this.menuContentElements.forEach((menuContent) => {
      const menuContentHeight = menuContent.offsetHeight;
      if(menuContentHeight > preserveTallestMenuHeight) {
        preserveTallestMenuHeight = menuContentHeight;
      }
    })

    return preserveTallestMenuHeight;
  }

  setMenuHeight(el: HTMLElement) {
    el.style.setProperty('--mega-menu-height', `${this.getTallestFromMenuItem()}px`)
  }

  clearMenuHeight(el: HTMLElement) {
    preserveTallestMenuHeight = 0;
    el.style.removeProperty('--mega-menu-height')
  }

  onResizeUpdateMenuHeight() {
     this.clearMenuHeight(this);
    this.setMenuHeight(this);
  }

}